import React from 'react';
import './App.css';
import './Tooltip.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Landing from './Landing.js';
import Room from './Room.js';
import NotFound from './NotFound.js';
import Trailer from './trailer/Trailer.js';

function App() {
  return (
    <div className='MainContainer'>
      <Router>
        <Switch>
          <Route exact path="/">
            <Landing />
          </Route>
          <Route exact path="/game/:id">
            <Room />
          </Route>
          <Route exact path="/trailer">
            <Trailer />
          </Route>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
